module.exports = __webpack_public_path__ + "static/media/IMG_0445 (1).6fe7bae6.JPG";